export const NO_CUTTING_WORK = "NO_CUTTING_WORK";
export const NO_CUTTING_SLIDES = "NO_CUTTING_SLIDES";
export const UNEVEN_PRINT_CASES_LIST = "UNEVEN_PRINT_CASES_LIST";
